import { useContext, useEffect } from 'react';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';

import { Businesses } from 'lib/api';
import { BUSINESSES_ACTIONS } from 'context/businesses/businessReducer';
import { BusinessContext } from 'context/businesses/businessContext';
import BusinessTableRow from './BusinessTableRow/BusinessTableRow';
import './BusinessesTable.css';

const { SET_BUSINESSES } = BUSINESSES_ACTIONS;
const TableColumns = [
    { label: 'ADMIN' },
    { label: 'PREFUND TYPE' },
    { label: 'ADMIN PHONE' },
    { label: 'BUSINESS' },
    { label: 'BANK' },
    { label: 'APPLICATION DATE' },
    { label: 'BALANCE' },
    { label: 'WEBSITE' },
    { label: 'ACTIONS' }
];

const BusinessesTable = () => {
    const {
        state: { businesses, reloadBusinesses },
        dispatch
    } = useContext(BusinessContext);

    useEffect(() => {
        const fetchBusinesses = async () => {
            try {
                const { rows: businessList } = await Businesses.getBusinesses();
                dispatch({ type: SET_BUSINESSES, payload: businessList });
            } catch (error) {
                console.error(error);
            }
        };
        fetchBusinesses();
    }, [dispatch, reloadBusinesses]);

    return (
        <Box className="table-container">
            <Box className="table-name">Applicants</Box>
            <TableContainer component={Paper} sx={{ maxHeight: 1440 }}>
                <Table>
                    <TableHead>
                        <TableRow className="table-header-row">
                            {TableColumns.reduce((tableCells, currentCell, index) => {
                                return tableCells.concat(
                                    <TableCell
                                        key={index}
                                        className="table-header-cell"
                                        sx={{
                                            textAlign: businesses.length === 0 ? 'center' : 'left'
                                        }}>
                                        {currentCell.label}
                                    </TableCell>
                                );
                            }, [])}
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ height: businesses?.length === 0 && '536px' }}>
                        {businesses.map(business => (
                            <BusinessTableRow key={business.id_business} row={business} />
                        ))}
                        {businesses.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={9} sx={{ textAlign: 'center' }}>
                                    <BusinessIcon className="no-data-icon" />
                                    <Typography paragraph className="no-data-text">
                                        There are no applicants!
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default BusinessesTable;
